var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClipper = function SvgClipper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 7a2 2 0 0 1 2 2v30a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2h30zM24.3 20 23 22.7l-3 .4 2.1 2-.5 3 2.7-1.4 2.6 1.4-.5-3 2.2-2-3-.4-1.3-2.7zM121 7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H49a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2h72z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 65a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h4zm108-16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H49a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h72zm0-14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H49a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h72zM91 21a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H49a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h42z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 65h28a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H93a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2z"
  }))));
};
export default SvgClipper;